import api from '../../utils/api';

export const getStemKits = () => api.get(`/stem_kits`);
export const getStemKit = (id) => api.get(`/stem_kits/${id}`);
export const addStemKitOrderApi = (data) => api.post('/orderings', data)
export const buyStemKitApi = (data) => api.post('/buy_stem_kits', data)